import { render, staticRenderFns } from "./PricingTableDesktopDetail.vue?vue&type=template&id=53a2d9f6&scoped=true"
import script from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js"
export * from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2d9f6",
  null
  
)

export default component.exports